/* eslint-disable vue/no-use-v-if-with-v-for */ /* eslint-disable vue/no-unused-vars */
<template>
  <div class="grid">
    <div class="grid-title">
      <h4>{{ $t("MANAGE_SYNC_OTA") }}</h4>
    </div>
    <div class="grid-body p-3 border-top-unset">
      <v-progress-linear
        color="warning"
        :indeterminate="true"
        rounded
        height="3"
        v-if="isLoading"
      ></v-progress-linear>
      <v-row v-if="!isLoading">
        <v-col sm="3" class="pb-0">
          <v-btn color="primary" class="w-100" outlined medium @click="addNew()">
            <v-icon color="#173d8f" small>add</v-icon>
            <label class="has-action fs-12">{{ $t("ADD_NEW_SALE_CHANNEL") }}</label>
          </v-btn>
          <v-list dense>
            <v-list-item-group mandatory v-model="selectedItem" color="primary">
              <v-list-item
                v-for="(item, i) in listOTAConnected"
                :key="i"
                :value="item.id"
              >
                <v-list-item-content>
                  <v-list-item-title
                    v-text="item.ota.otaI18n.find((x) => x.lang == defaultI18n).name"
                  >
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-icon :color="item.otaStatus ? 'primary ' : '#6d6d6d'"
                    >cloud_done</v-icon
                  >
                </v-list-item-icon>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-col>

        <v-col
          v-if="!isError && !isBeConnected"
          sm="9"
          class="pb-0"
          style="border-left: 1px solid #cdcdcd"
        >
          <v-row align="center">
            <v-col sm="2">
              <label>OTA ID</label>
            </v-col>
            <v-col sm="4">
              <v-text-field
                dense
                outlined
                disabled
                v-model="conectedDetail.otaHotelCode"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row align="center">
            <v-col sm="2">
              <label>{{ $t("CURRENCY_OTA") }}</label>
            </v-col>
            <v-col sm="4">
              <v-text-field
                dense
                outlined
                disabled
                v-model="conectedDetail.currencyCode"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row align="center">
            <v-col sm="3">
              <label>{{ $t("PRICE_ON_OTA") }}</label>
              <v-tooltip top color="rgba(0, 62, 148,1)">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    color="primary"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    class="pl-2 pr-10"
                    size="18"
                  >
                    info
                  </v-icon>
                </template>
                <div class="description-price" v-html="$t('EXAMPLE_INFO')"></div>
              </v-tooltip>
              =
            </v-col>
            <!-- <v-col sm="1" style="text-align-last: center">
              <label> = </label>
            </v-col> -->
            <v-col sm="2">
              {{ $t("PRICE_ON_DEFINED") }}
            </v-col>
            <v-col sm="1" style="text-align-last: center">
              <label> x </label>
            </v-col>
            <v-col sm="2">
              <v-text-field
                dense
                outlined
                v-model="conectedDetail.rateIndex"
                :label="$t('RATES')"
              ></v-text-field>
            </v-col>
            <v-col sm="1" style="text-align-last: center">
              <label>+</label>
            </v-col>
            <v-col sm="3">
              <v-text-field
                dense
                outlined
                v-model="conectedDetail.rateSupplement"
                :label="$t('RATES_OSCILLATE')"
              >
              </v-text-field>
            </v-col>
          </v-row>

          <v-row class="mapping-roomtype">
            <v-col class="pr-2">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th width="50%" style="color: #000 !important">
                        {{ $t("ROOM_TYPE_ON_OTA") }}
                      </th>
                      <th width="50%" style="color: #000 !important">
                        {{ $t("ROOM_TYPE") }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-if="conectedDetail.otaExternalRoomType.length > 0">
                      <tr
                        v-for="(item, i) in conectedDetail.otaExternalRoomType"
                        :key="i"
                      >
                        <td width="50%" class="vertical-middle">
                          {{ item.name }} ({{ $t("HOTEL_LOG_id") }}: {{ item.id }})
                        </td>
                        <td width="50%">
                          <v-select
                            item-text="text"
                            item-value="value"
                            dense
                            outlined
                            :items="
                              filterSelectRoomType(
                                conectedDetail.otaRoomType.find(
                                  (x) => x.otaRoomTypeCode == item.id
                                ).roomType.id
                              )
                            "
                            v-model="
                              conectedDetail.otaRoomType.find(
                                (x) => x.otaRoomTypeCode == item.id
                              ).roomType.id
                            "
                          ></v-select>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>

          <v-row class="mapping-roomrate">
            <v-col class="pr-2">
              <v-simple-table class="sync-table">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th width="50%" style="color: #000 !important">
                        {{ $t("SALE_PACKAGE_ON_OTA") }}
                      </th>
                      <th width="50%" style="color: #000 !important">
                        {{ $t("SALE_PACKAGE") }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <template
                      v-if="conectedDetail.otaExternalRatePlan.length > 0"
                      v-for="(item, i) in conectedDetail.otaExternalRatePlan"
                    >
                      <tr
                        width="50%"
                        :class="item.occupancies.length > 0 ? 'has-sub' : ''"
                      >
                        <td class="vertical-middle">
                          {{ item.name }}
                          ({{ $t("HOTEL_LOG_id") }}: {{ item.id }})
                        </td>
                        <td width="50%">
                          <v-select
                            class="select-fs-12"
                            item-text="text"
                            item-value="value"
                            dense
                            outlined
                            :items="
                              filterSelectRatePlan(
                                conectedDetail.otaRatePlan.find(
                                  (x) => x.otaPlanCode == item.id
                                ).ratePlan.id
                              )
                            "
                            v-model="
                              conectedDetail.otaRatePlan.find(
                                (x) => x.otaPlanCode == item.id
                              ).ratePlan.id
                            "
                          ></v-select>
                        </td>
                      </tr>
                      <tr v-if="item.occupancies.length > 0" class="has-sub">
                        <td
                          colspan="3"
                          class="pr-2"
                          style="
                            background-color: rgba(249, 245, 245, 0.75);
                            border-bottom: 0;
                            padding-bottom: 0 !important;
                          "
                        >
                          <ul class="sub-item">
                            <li class="header">
                              <div class="item-name">
                                {{ $t("ROOM_TYPE_ON_OTA") }}
                              </div>
                              <div class="item-quantity">
                                {{ $t("NUMBER_OF_PERSON") }}
                              </div>
                              <div class="item-room">
                                {{ $t("ROOM_TYPE") }}
                              </div>
                            </li>
                            <template
                              v-for="(occupancyRoomId, i) in Object.keys(
                                item.occupancies[0]
                              )"
                            >
                              <template
                                v-for="(occupancyId, i) in Object.keys(
                                  item.occupancies[0][occupancyRoomId]
                                )"
                              >
                                <li class="item-detail">
                                  <div class="item-name">
                                    {{
                                      conectedDetail.otaExternalRoomType.find(
                                        (x) => x.id == occupancyRoomId
                                      ).name
                                    }}
                                  </div>
                                  <div class="item-quantity">
                                    {{
                                      item.occupancies[0][occupancyRoomId][occupancyId]
                                    }}
                                  </div>
                                  <div class="item-room">
                                    <v-select
                                      class="select-fs-12"
                                      item-text="text"
                                      item-value="value"
                                      dense
                                      outlined
                                      :items="
                                        filertSelectOccupancy(
                                          conectedDetail.otaOccupancies.find(
                                            (x) =>
                                              x.otaRoomTypeCode == occupancyId ||
                                              x.otaRoomTypeCode
                                                .split('|')
                                                .includes(occupancyId)
                                          ).roomType.id,
                                          occupancyRoomId
                                        )
                                      "
                                      v-model="
                                        conectedDetail.otaOccupancies.find(
                                          (x) =>
                                            x.otaRoomTypeCode == occupancyId ||
                                            x.otaRoomTypeCode
                                              .split('|')
                                              .includes(occupancyId)
                                        ).roomType.id
                                      "
                                    ></v-select>
                                    <!-- listSelectOccupancy.filter(
                                          y =>
                                            y.value ==
                                              conectedDetail.otaRoomType.find(
                                                x =>
                                                  x.otaRoomTypeCode ==
                                                  occupancyRoomId
                                              ).roomType.id ||
                                            y.parentId ==
                                              conectedDetail.otaRoomType.find(
                                                x =>
                                                  x.otaRoomTypeCode ==
                                                  occupancyRoomId
                                              ).roomType.id
                                        ) -->
                                  </div>
                                </li>
                              </template>
                            </template>
                          </ul>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>

          <div class="text-right">
            <v-btn color="primary" class="pr-10 pl-10" :disabled="isLoadingPopup" @click="update()">
              {{ $t("SAVE") }}</v-btn
            >
          </div>
        </v-col>
        <v-col
          v-else-if="!isError && isBeConnected"
          sm="9"
          class="pb-0"
          style="border-left: 1px solid #cdcdcd"
        >
          <v-row style="text-align: center" v-if="!isGoogleHotel">
            <v-col sm="12">
              <v-icon color="primary" size="150">cloud_done</v-icon>
              <p class="font-weight-bold fs-18">
                {{ $t("HAS_CONNECTED") }}
              </p>
            </v-col>
          </v-row>
          <template v-if="isGoogleHotel">
            <div class="roomRate-ota">
              <label class="label-title mb-3">{{
                $t("ROOM_AND_PACKAGES_FOR_SALE_ON_GOOOGLE")
              }}</label>
              <ul class="ul-parent">
                <li class="li-parent" v-for="(item, index) in RoomRateByOta" :key="index">
                  <p class="mb-0">
                    <strong>{{
                      item.roomTypeI18n.find((e) => e.lang === defaultI18n).name
                    }}</strong>
                  </p>
                  <ul>
                    <li class="li-child" v-for="(rate, ind) in item.ratePlans" :key="ind">
                      {{ rate.i18ns.find((e) => e.lang === defaultI18n).name }}
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </template>
        </v-col>
        <v-col v-else sm="9" class="pb-0" style="border-left: 1px solid #cdcdcd">
          <v-row style="text-align: center">
            <v-col sm="12">
              <v-icon style="height: 100%; font-size: 150px" color="#fed12f"
                >warning</v-icon
              >
            </v-col>
            <v-col sm="12">
              <p style="margin: auto">
                {{ $t("CANNOT_GET_INFO_FROM_OTA_1") }}
                <br />
                {{ $t("CANNOT_GET_INFO_FROM_OTA_2") }}
              </p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>

    <v-dialog v-model="popupAddNew" width="500">
      <v-card class="popup-add-new-channel">
        <template v-if="!isStep2">
          <v-autocomplete
            item-text="text"
            item-value="value"
            :items="listSelectOTA"
            :label="$t('SELECT_SALE_CHANNEL')"
            dense
            outlined
            v-model="selectedOTA"
          >
            <template slot="no-data">
              <div class="no-data">{{ $t("NO_DATA") }}</div>
            </template>
          </v-autocomplete>

          <div class="instruction" v-html="descriptionOTA"></div>
          <div class="instruction text-danger fs-10" v-if="errNullSelect">
            {{ errNullSelect }}
          </div>

          <v-divider></v-divider>

          <div class="text-center">
            <v-btn color="primary" @click="step2()">
              {{ $t("CONNECT") }}
            </v-btn>
          </div>
        </template>
        <template v-if="isStep2">
          <loading :active.sync="isLoadingPopup" :is-full-page="false"></loading>
          <v-row v-for="(value, key) in form">
            <v-col class="pt-0 pb-0">
              <label>{{ $t(key) }}</label>
              <v-text-field
                dense
                outlined
                v-model="form[key]"
                :placeholder="$t(key)"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="connect()">
              {{ $t("CONNECT") }}
            </v-btn>
          </v-card-actions>
        </template>
      </v-card>
    </v-dialog>
  </div>
</template>

<style lang="scss" scoped>
.description-price {
  padding: 10px;

  p {
    margin-bottom: 2px;

    span {
      font-weight: bold;
    }
  }
}

.main-table {
  width: 100%;
}

.main-table td > span {
  font-size: 14px !important;
}
</style>

<script>
import { REGEX_NUMBER } from "@/_helpers/constant.js";
import { _alert } from "@/_helpers/function.js";
import { syncota } from "@/_services/SyncOTA/syncota.js";
import { service } from "@/_services/RoomInfomation/list-of-rooms.service.js";
import { salePackageService } from "@/_services/SaleRoom/sale-package.service.js";
import { restriction } from "@/_services/SaleRoom/restriction.js";
import moment from "moment";

export default {
  components: {},
  data() {
    return {
      sysLang: this.$i18n.locale,
      popupAddNew: false,
      isLoading: false,
      dataAllOTA: [],
      listSelectOTA: [],
      listOTAConnected: [],
      selectedItem: 0,
      descriptionOTA: "",
      selectedOTA: "",
      isStep2: false,
      idOTA: "",
      username: "",
      password: "",
      allRoomType: "",
      listSelectRoomType: [],
      allRatePlan: "",
      listSelectOccupancy: [],
      listSelectRatePlan: [],
      conectedDetail: "",
      isLoadingPopup: false,
      form: {
        // otaUsername: '',
        // otaHotelCode: '',
        // otaPassword: '',
      },
      isError: false,
      connectionType: null,
      otaCode: null,
      currentSubView: null,
      // Check điều kiện nếu là BE thì ko hiển thị thông tin mapping phòng
      isBeConnected: false,
      RoomRateByOta: [],
      isGoogleHotel: false,
      errNullSelect: null,
      otaExternalRoomTypeIds: [],
    };
  },
  computed: {
    REGEX_NUMBER() {
      return REGEX_NUMBER;
    },
    roomTypeIds() {
      const arr = this.conectedDetail.otaRoomType.map((x) => {
        if (this.otaExternalRoomTypeIds.includes(x.otaRoomTypeCode)) {
          return x.roomType.id;
        } else return null;
      });
      var newArr = [];
      newArr = arr.filter(function (item) {
        return newArr.includes(item) ? "" : newArr.push(item);
      });
      return newArr.filter((e) => e !== null);
    },
    RatePlanIds() {
      const arr = this.conectedDetail.otaRatePlan.map((x) => {
        return x.ratePlan.id;
      });
      return arr.filter((e) => e !== null);
    },
    occupancyRoomIds() {
      const arr = this.conectedDetail.otaOccupancies.map((x) => {
        return x.roomType.id;
      });
      return arr.filter((e) => e !== null);
    },
  },
  created() {
    this.initialize();
  },
  watch: {
    selectedOTA(value) {
      if (value) {
        this.errNullSelect = null;
      }
      // this.descriptionOTA = this.dataAllOTA.find((x) => x.id == value).instructionVi;
      const foundOTA = this.dataAllOTA.find((x) => x.id == value);
      if (foundOTA) {
        const otaI18n = foundOTA.otaI18n.find((y) => y.lang == this.defaultI18n);
        this.descriptionOTA = otaI18n ? otaI18n.description : "";
      } else {
        this.descriptionOTA = "";
      }
      // // console.log( JSON.parse( this.dataAllOTA.find( x => x.id == value ).credentialsVi ) );
      this.connectionType = this.dataAllOTA.find((x) => x.id == value).connectionType;

      this.otaCode = this.dataAllOTA.find((x) => x.id == value).otaCode;
      this.form = {};
      this.form = Object.assign(
        this.form,
        JSON.parse(this.dataAllOTA.find((x) => x.id == value).credentialsVi)
      );
    },
    selectedItem(value) {
      // Lấy thông tin chi tiết đồng bộ của 1 kênh
      this.isLoading = true;
      this.isError = false;
      this.conectedDetail = "";
      syncota
        .detailSyncOTA(value)
        .then((res) => {
          if (res.responseCode === 0) {
            this.conectedDetail = res.data;
            if (res.data.otaExternalRoomType) {
              this.otaExternalRoomTypeIds = this.conectedDetail.otaExternalRoomType.map(
                (x) => {
                  return x.id;
                }
              );
            }
            // Nếu chọn OTA là BE
            if (res.data == "CONNECTED") {
              this.isBeConnected = true;
            } else {
              this.isBeConnected = false;
            }
            const otaCode = this.listOTAConnected.find((e) => e.id === value).otaCode;
            if (otaCode === "EZ_GOOGLE_HOTEL") {
              this.isGoogleHotel = true;
              this.getRateByOta(
                this.listOTAConnected.find((e) => e.otaCode === "EZ_BE").ota.id
              );
            } else {
              this.isGoogleHotel = false;
            }
          } else {
            if (res.data == "OTA_CONNECTION_ERROR") {
              this.isError = true;
            } else {
              _alert(res, this.$t(res.data), false);
            }
          }
        })
        .finally(() => (this.isLoading = false));
    },
  },
  methods: {
    filterSelectRoomType(id) {
      const arr = this.listSelectRoomType
        .filter((x) => x.parentId == null)
        .map((e) => {
          if (!this.roomTypeIds.includes(e.value) || e.value === id || e.value === null) {
            return e;
          } else {
            return "delete";
          }
        });
      return arr.filter((e) => e !== "delete");
    },
    filterSelectRatePlan(id) {
      const arr = this.listSelectRatePlan.map((e) => {
        if (!this.RatePlanIds.includes(e.value) || e.value === id || e.value === null) {
          return e;
        } else {
          return "delete";
        }
      });
      return arr.filter((e) => e !== "delete");
    },
    filertSelectOccupancy(id, occupancyRoomId) {
      const arr = this.listSelectOccupancy.filter(
        (y) =>
          y.value ==
            this.conectedDetail.otaRoomType.find(
              (x) => x.otaRoomTypeCode == occupancyRoomId
            ).roomType.id ||
          y.parentId ==
            this.conectedDetail.otaRoomType.find(
              (x) => x.otaRoomTypeCode == occupancyRoomId
            ).roomType.id
      );
      // .map(e => {
      //   if (
      //     !this.occupancyRoomIds.includes(e.value) ||
      //     e.value === id ||
      //     e.value === null
      //   ) {
      //     return e;
      //   } else {
      //     return "delete";
      //   }
      // });
      return arr.filter((e) => e !== "delete");
    },
    async initialize() {
      this.isLoading = true;
      let body = {
        keyword: "",
        status: 1,
      };
      await syncota.getAllOTANotConnect(body).then((res) => {
        if (res.responseCode === 0) {
          this.dataAllOTA = res.data;
          this.listSelectOTA = res.data
            .filter((e) => e.connection !== "NONE")
            .map((x) => {
              return {
                value: x.id,
                text: x.otaI18n.find((y) => y.lang == this.defaultI18n).name,
              };
            });
          this.listSelectOTA = this.listSelectOTA.filter((x) => x.value);

          this.listSelectOTA.sort(function (a, b) {
            var nameA = a.text.toLowerCase(),
              nameB = b.text.toLowerCase();
            if (nameA < nameB) return -1;
            if (nameA > nameB) return 1;
            return 0;
          });
        } else {
          _alert(res, this.$t(res.data), false);
        }
      });

      await syncota.getConnectedOTA(body).then((res) => {
        if (res.responseCode === 0) {
          this.listOTAConnected = res.data.filter((e) => e.ota.connection !== "NONE");
          if (this.listOTAConnected.length > 0) {
            this.selectedItem = this.listOTAConnected[0].id;
          } else {
            this.isError = true;
            this.isLoading = false;
          }
        } else {
          _alert(res, this.$t(res.data), false);
        }
      });

      // Lấy tất cả phòng
      let allroom = {};
      allroom.keyword = "";
      allroom.status = "1";
      allroom.limit = 1000;
      allroom.offset = 0;
      allroom.orderBy = "active";
      allroom.asc = false;

      await service.getAllRooms(allroom).then((res) => {
        this.allRoomType = res.data;
        this.listSelectRoomType.push({
          value: null,
          text: this.$t("_REGISTER.SELECT"),
        });

        this.listSelectRoomType = this.listSelectRoomType.concat(
          res.data.map((x) => {
            return {
              value: x.roomId,
              text:
                x.i18ns.find((x) => x.lang == this.defaultI18n).name +
                " (" +
                this.$t("HOTEL_LOG_id") +
                ": " +
                x.roomCode +
                ")",
              parentId: x.parentId,
            };
          })
        );
        this.listSelectOccupancy.push({
          value: null,
          text: this.$t("_REGISTER.SELECT"),
        });

        this.listSelectOccupancy = this.listSelectRoomType.concat(
          res.data.map((x) => {
            return {
              value: x.roomId,
              text:
                x.i18ns.find((x) => x.lang == this.defaultI18n).name +
                " (" +
                this.$t("HOTEL_LOG_id") +
                ": " +
                x.roomCode +
                ")",
            };
          })
        );
      });

      // Lấy tất cả gói bán
      let allrateplan = {};
      allrateplan.keyword = "";
      allrateplan.status = "1";
      allrateplan.limit = 1000;
      allrateplan.offset = 0;
      allrateplan.orderBy = "active";
      allrateplan.asc = false;

      await salePackageService.getAllPlan(allrateplan).then((res) => {
        this.allRatePlan = res.data;

        this.listSelectRatePlan.push({
          value: null,
          text: this.$t("_REGISTER.SELECT"),
        });
        this.listSelectRatePlan = this.listSelectRatePlan.concat(
          res.data.map((x) => {
            return {
              value: x.id,
              text:
                x.i18ns.find((x) => x.lang == this.defaultI18n).name +
                " (" +
                this.$t("HOTEL_LOG_id") +
                ": " +
                x.ratePlanCode +
                ")",
            };
          })
        );
      });
    },
    addNew() {
      this.popupAddNew = true;
    },
    update() {
      this.isLoading = true;
      let connectSaving = this.conectedDetail;
      connectSaving.otaRoomType.forEach((otaRoomType) => {
        connectSaving.otaOccupancies.forEach((otaOccupancies) => {
          if (otaRoomType.otaRoomTypeCode === otaOccupancies.otaRoomTypeCode) {
            otaRoomType.roomType = otaOccupancies.roomType;
          }
        });
      });
      syncota
        .updateDetailSyncOTA(connectSaving)
        .then((res) => {
          _alert(res, this.$t(res.data), false);
          this.callApiListOta();
        })
        .finally(() => (this.isLoading = false));
    },
    async callApiListOta() {
      let body = {
        keyword: "",
        status: 1,
      };
      await syncota.getConnectedOTA(body).then((res) => {
        if (res.responseCode === 0) {
          this.listOTAConnected = res.data;
        } else {
          _alert(res, this.$t(res.data), false);
        }
      });
    },
    step2() {
      if (this.selectedOTA) {
        if (
          this.connectionType == 3 ||
          this.dataAllOTA.find((x) => x.id == this.selectedOTA).connection === "NONE"
        ) {
          this.connect();
          // Nếu chọn thêm mới BE
        } else if (
          this.connectionType == 1 &&
          (this.otaCode == "EZ_BE" || this.otaCode == "EZ_GOOGLE_HOTEL")
        ) {
          this.connect();
          // Đóng popup thêm mới
          this.popupAddNew = false;
        } else {
          this.isStep2 = true;
        }
      } else {
        this.errNullSelect = this.$t("CHANNEL_EMPTY");
      }
    },
    connect() {
      let body = {
        ota: {
          id: "",
        },
        credential: {},
      };

      body.ota.id = this.selectedOTA;
      for (const [key, value] of Object.entries(this.form)) {
        if (
          `${key}` != "otaUsername" &&
          `${key}` != "otaHotelCode" &&
          `${key}` != "otaPassword"
        ) {
          body["credential"][`${key}`] = `${value}`;
        } else {
          body[`${key}`] = `${value}`;
        }
      }
      this.isLoadingPopup = true;
      syncota
        .createConnectOTA(body)
        .then((res) => {
          if (res.responseCode == 0) {
            if (this.connectionType == 3) {
              window.location.replace(res.data);
            } else {
              _alert(res, this.$t(res.data), true);
            }
          } else {
            _alert(res, this.$t(res.data), true);
            location.reload();
          }
        })
        .finally(() => (this.isLoadingPopup = false));
    },
    viewDetail(i) {
      this.currentSubView = i;
    },
    async getRateByOta(otaId) {
      await restriction.getAllOtaHasRoomRate(otaId).then((res) => {
        if (res.responseCode == 0) {
          this.RoomRateByOta = [];
          if (res.data.length > 0) {
            this.RoomRateByOta = res.data;
            // console.log(this.RoomRateByOta);
          } else {
            this.RoomRateByOta = [];
          }
        }
      });
    },
    _moment: moment,
  },
};
</script>
